import React, { useEffect, useState } from 'react';
import './App.css';

function App() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className="App">
      {/* Navbar */}
      <nav className={`navbar ${isScrolled ? 'solid' : 'transparent'}`}>
        <div className="container">
          <h1 className="logo">Gourmatch</h1>
          <ul className="nav-links">
            <li><a href="#what-we-offer">What We Offer</a></li>
            <li><a href="#how-it-works">How It Works</a></li>
            <li><a href="#contact">Contact</a></li>
          </ul>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          <h1>We Give AI the Sense of Taste</h1>
          <br></br>
          <p>Everything is personalized with AI, except taste.
            <br></br>
            Our sensory device understand taste in seconds.
            <br></br>
            Our AI discovers your unique palate. 
            <br></br>
            Say goodbye to guesswork and hello to personalized delight.</p>
          <a href="#contact" className="cta-button">Plan a Demo</a>
        </div>
      </section>

      {/* Statistics Section 2 */}
      <section className="stats-section">
        <div className="container stats-grid-container">
          <div className="stats-left-content">
            {/* <p class="tag-line">-</p> */}
            <h2>What if <br></br> we could <br></br> understand <br></br> flavor before <br></br> tasting it?</h2>
          </div>
          <div className="stats-grid">
            <div className="stat-card">
              <p className="stat-label">GLOBAL F&B INDUSTRY VOLUME</p>
              <p className="stat-value">$9.3T</p>
            </div>
            <div className="stat-card">
              <p className="stat-label">RESTAURANT REVIEWS</p>
              <p className="stat-value">92%</p>
              <p className="stat-description">of consumers read restaurant reviews for where to eat</p>
            </div>
            <div className="stat-card">
              <p className="stat-label">TARGETED ADS FOR PURCHASE</p>
              <p className="stat-value">65%</p>
              <p className="stat-description">of consumers see targeted ads as the top reason for purchase</p>
            </div>
            <div className="stat-card">
              <p className="stat-label">TRUST IN BLOG REVIEWS</p>
              <p className="stat-value">79%</p>
              <p className="stat-description">of customers trust blogs for information about food</p>
            </div>
            <div className="stat-card">
              <p className="stat-label">REVIEW WHILE SHOPPING</p>
              <p className="stat-value">53%</p>
              <p className="stat-description">consult reviews on their phones while in aisle during shopping</p>
            </div>
            <div className="stat-card">
              <p className="stat-label">TASTE IS KING</p>
              <p className="stat-value">72%</p>
              <p className="stat-description">of consumers rank taste above all other factors such as price and health considerations</p>
            </div>
          </div>
        </div>
      </section>

      {/* Statistics Section */}
      <section className="stats-section">
        <div className="container stats-grid-container">
          <div className="stats-left-content">
            {/* <p class="tag-line">-</p> */}
            <h2>What if <br></br> we could <br></br> match every <br></br> product to <br></br> the right <br></br> person?</h2>
          </div>
          <div className="stats-grid">
            <div className="stat-card">
              <p className="stat-label">TOTAL US F&B AD SPEND</p>
              <p className="stat-value">$15B+</p>
            </div>
            <div className="stat-card">
              <p className="stat-label">ALCOHOL AD SPEND (US)</p>
              <p className="stat-value">$1.7B</p>
            </div>
            <div className="stat-card">
              <p className="stat-label">PERSONALISATION DEMAND</p>
              <p className="stat-value">96%</p>
              <p className="stat-description">of consumers prefer personalized ads</p>
            </div>
            <div className="stat-card">
              <p className="stat-label">OF ADS IGNORED</p>
              <p className="stat-value">81%</p>
            </div>
            <div className="stat-card">
              <p className="stat-label">DATA GAP</p>
              <p className="stat-value">77%</p>
              <p className="stat-description">of marketers have no targeting data in F&B</p>
            </div>
            <div className="stat-card">
              <p className="stat-label">ROI POTENTIAL</p>
              <p className="stat-value">50%</p>
              <p className="stat-description">by targeting & personalisation</p>
            </div>
          </div>
        </div>
      </section>

      {/* What Gourmatch Offers Section */}
      <section id="what-we-offer" className="offers-section">
        <div className="container">
          <h2>What Gourmatch Offers</h2>
          <div className="cards-container">
            <div className="card">
              <h3>A Personalized Discovery</h3>
              <p> Taste-matching experience. </p>
              {/* Gourmatch uses its sensor technology to analyze taste preferences of consumers and to suggest food and baverages they will enjoy. */}
              {/* <img src="https://via.placeholder.com/150" alt="Placeholder 1" /> */}
            </div>
            
            {/* <div className="card">
              <h3>Supply Chain Optimization</h3>
              <p>AI-powered demand simulator and market insights for businesses. </p>
              <img src="https://via.placeholder.com/150" alt="Placeholder 2" />
            </div> */}

            <div className="card">
              <h3>Taste-Revealing</h3>
              <p>Personalized product recommendations.</p>
              {/* <img src="https://via.placeholder.com/150" alt="Placeholder 3" /> */}
            </div>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section id="how-it-works" className="how-it-works-section">
        <div className="container">
          <h2>How It Works</h2>
          <div className="steps-container">
            <div className="step-card">
              <i className="icon">Sensor</i>
              <h3>Taste Sensor</h3>
              <p>Fingerprint of any food.</p>
            </div>
            <div className="step-card">
              <i className="icon">AI Engine</i>
              <h3>Taste Mapping</h3>
              <p>Our intelligent algorithms find your perfect culinary matches.</p>
            </div>
            <div className="step-card">
              <i className="icon">Matching</i>
              <h3>Enjoy & Explore</h3>
              <p>Savor personalized recommendations and discover new delights.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer id="contact" className="footer">
        <div className="container">
          <p>&copy; 2025 Gourmatch. All rights reserved.</p>
          <p>Contact: <a href="mailto:info@gourmatch.app">info@gourmatch.app</a></p>
          <div className="footer-links">
            <a href="#privacy">Privacy Policy</a>
            <a href="#terms">Terms of Service</a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
